const SITE_ID = 22;const SITE_UID='653267d4-6d82-4b5d-91ef-7c419dfbbc49';const SUBDOMAIN='yw';export { SITE_ID, SITE_UID, SUBDOMAIN }